import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Event from './component/event/event';
import SuccessRegistration from './component/successRegistration/successRegistration';
import CancelRegistration from './component/cancelRegistration/cancelRegistration';

export default function RouterApp() {
  return (
    <Router>
      <Switch>
        <Route path="/event/:eventId" exact>
          <Event />
        </Route>
        <Route path="/event/:eventId/:eventRegistrationId" exact>
          <Event />
        </Route>
        <Route path="/successregistration/:eventId">
          <SuccessRegistration />
        </Route>
        <Route path="/cancelregistration/:eventId/:eventRegistrationId">
          <CancelRegistration />
        </Route>
      </Switch>
    </Router>
  );
}
